
/* injects from baggage-loader */

'use strict';

import OnboardingApplicationController from './onboarding-application.controller';
import OnboardingApplicationTemplate from './onboarding-application.html';

export default class OnboardingApplicationComponent {
		constructor() {
				this.templateUrl = OnboardingApplicationTemplate;
				this.controller = OnboardingApplicationController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					onboarding: '<'
				};
		}
}
